import { render, staticRenderFns } from "./expertIntroduction.vue?vue&type=template&id=d150c940&scoped=true"
import script from "./expertIntroduction.vue?vue&type=script&lang=js"
export * from "./expertIntroduction.vue?vue&type=script&lang=js"
import style0 from "./expertIntroduction.vue?vue&type=style&index=0&id=d150c940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d150c940",
  null
  
)

export default component.exports